var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('background-configuration')],1),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('term-ordering-configuration')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }